import { useState, useEffect } from 'react';
import { getReportePuntoVenta, ReportePVRow } from '../../../../service/reportes/ReportePuntoVenta';

export function useReportePV(ids_dia: number[]) {
  const [list, setList] = useState<ReportePVRow[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (ids_dia.length === 0) {
      setList([]);
      return;
    }
    setLoading(true);
    getReportePuntoVenta(ids_dia)
      .then(setList)
      .catch(() => setList([]))
      .finally(() => setLoading(false));
  }, [ids_dia.join(',')]); // eslint-disable-line react-hooks/exhaustive-deps

  return { list, loading };
}
